import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as jwt_decode from 'jwt-decode';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { environment } from '../../../environments/environment';
import { Authority } from 'src/app/shared/constants/authority.constants';
import { AccountService } from './account.service';

@Injectable({ providedIn: 'root' })
export class AuthServerProvider {
  constructor(
    private http: HttpClient, 
    private $localStorage: LocalStorageService, 
    private $sessionStorage: SessionStorageService,
    private accountService: AccountService,
    ) {}

  getToken() {
    const token = this.$localStorage.retrieve(environment.KEY_TOKEN);
    return  token || this.$sessionStorage.retrieve(environment.KEY_TOKEN);
  }

  login(credentials): Observable<any> {
    const data = {
      username: credentials.username,
      password: credentials.password,
      code: credentials.code,
      rememberMe: credentials.rememberMe
    };
    const formData = new FormData();
    formData.append('username', credentials.username);
    formData.append('password', credentials.password);
    return this.http.post(environment.SERVER_API_URL + 'login', formData, { observe: 'response' })
    .pipe(map((resp: any) => {
      const token = resp.headers.get('x-auth-token');
      this.$sessionStorage.store('token', token);
      const acc = resp.body || {};
      acc.adminGroup = acc.adminGroup || {};
      acc.authorities  = [Authority.EMPLOYEE];
      if (acc.adminGroup.code === 'ADMIN') {
        acc.isAdmin = true;
        acc.authorities.push(Authority.ADMIN);
      };
      this.$sessionStorage.store('profile', acc);
      this.accountService.authenticate(acc);

      return acc;
    }));
  }

  loginWithToken(jwt, rememberMe) {
    if (jwt) {
      this.storeAuthenticationToken(jwt, rememberMe);
      return Promise.resolve(jwt);
    } else {
      return Promise.reject('auth-jwt-service Promise reject'); // Put appropriate error message here
    }
  }

  storeAuthenticationToken(jwt, rememberMe) {
    this.$localStorage.store(environment.KEY_TOKEN, jwt);
  }

  logout(){
    this.$localStorage.clear(environment.KEY_TOKEN);
    this.$sessionStorage.clear(environment.KEY_TOKEN);
    return this.http.get(environment.SERVER_API_URL + 'logout')
    .subscribe((resp: any) => {
      return resp;
    });
  }

  hasAnyAuthority(authorities: string[]): boolean {
    return true;
  }

  hasAuthority(authority: string): boolean {
    return true;
  }
}
